import React from 'react';
import ReactDOM from 'react-dom/client';
import { Analytics } from '@vercel/analytics/react';
import App from './App';
import './app.css';

const root = document.getElementById('app');
if (!root) throw new Error('Missing #app root');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
    <Analytics />
  </React.StrictMode>
);
